




































































































































import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'

@Component

export default class ComponenteBackofficePaciente extends Vue {
  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get classificacaoCirurgia() {
    const classificacao = new Map([
      ['Limpa', 'Limpa'],
      ['PotencialmenteContaminada', 'Potencialmente contaminada'],
      ['Contaminada', 'Contaminada'],
      ['Infectada', 'Infectada'],
    ])
    return classificacao.get(String(this.getBackofficeGlobalStore.solicitacao.classificacaoCirurgia)) || 'Não informado'
  }

  get exibirPacienteOncologico() {
    return this.campoHabilitado('classificacaoPacienteOncologico') &&
      this.getBackofficeGlobalStore.solicitacao.hasOwnProperty('pacienteEhOncologico')
  }

  get exibirPrimeiroTratamentoOncologico() {
    return this.campoHabilitado('primeiroTratamentoOncologico')
      && 'dataPrimeiroDiagnostico' in this.getBackofficeGlobalStore.solicitacao
  }

  get maskDataPrimeiroDiagnostico() {
    const { dataPrimeiroDiagnostico } = this.getBackofficeGlobalStore.solicitacao
    return dataPrimeiroDiagnostico ? moment(dataPrimeiroDiagnostico).format('DD/MM/YYYY') : '-'
  }

  exibirTempoDeDoenca(tempoDeDoenca: any) {
    const { anos, meses, dias } = tempoDeDoenca

    if (+anos < 1 && +meses < 1) {
      return `${dias} ${+dias < 2 ? 'dia' : 'dias'}`
    }

    if (+anos < 1 && meses > 1) {
      return `${meses} ${+meses < 2 ? 'mês' : 'meses'} e ${dias} ${+dias < 2 ? 'dia' : 'dias'}`
    }

    if (+anos > 0) {
      return `${anos} ${+anos < 2 ? 'ano' : 'anos'}, ${meses} ${+meses < 2 ? 'mês' : 'meses'} e ${dias} ${+dias < 2 ? 'dia' : 'dias'}`
    }

    return `${anos} ano(s), ${meses} mes(es) e ${dias} dia(s)`
  }

  campoHabilitado(prop: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop]
      if (response) return response.habilitado
    }

    return false
  }
}
